import {
    createNewProgramEditModel,
    editNewProgramFlow,
} from './newProgram';
import {
    createMergeProgramsEditModel,
    editMergeProgramsFlow,
} from './mergePrograms';
import {
    createConsolidateProgramsEditModel,
    editConsolidateProgramsFlow,
} from './consolidatePrograms';
import {
    createChangeDetailsEditModel,
    editChangeDetailsFlow,
} from './changeDetails';
import {
    createChangeStatusEditModel,
    editChangeStatusFlow,
} from './changeStatus';
import {
    createSplitProgramEditModel,
    editSplitProgramFlow,
} from './splitProgram';

export const editFlowRegistry = {
    createNew: {
        initialize: createNewProgramEditModel,
        submit: editNewProgramFlow,
    },
    merge: {
        initialize: createMergeProgramsEditModel,
        submit: editMergeProgramsFlow,
    },
    consolidate: {
        initialize: createConsolidateProgramsEditModel,
        submit: editConsolidateProgramsFlow,
    },
    changeDetails: {
        initialize: createChangeDetailsEditModel,
        submit: editChangeDetailsFlow,
    },
    changeStatus: {
        initialize: createChangeStatusEditModel,
        submit: editChangeStatusFlow,
    },
    split: {
        initialize: createSplitProgramEditModel,
        submit: editSplitProgramFlow,
    },
};
